import * as Sentry from '@sentry/tanstackstart-react';

/**
 * Initializes Sentry error monitoring on the client side.
 * Only active in production to avoid dev noise.
 */
export function initSentryClient() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    enabled: import.meta.env.PROD,
  });
}
